import React from 'react';
import Typography from '@material-ui/core/Typography';
import { When } from 'UI/components/atoms';

import { useStyles } from './EmailDetails.styled';

export const EmailDetails = ({ subject = null, preview = null }) => {
  const classes = useStyles();
  const hasSubject = !!subject;
  const hasPreview = !!preview;

  return (
    <Typography variant="body2" component="span" className={classes.root}>
      <When condition={hasSubject}>
        <span className={classes.subject}>{subject}</span>
      </When>
      <When condition={hasSubject && hasPreview}>{' - '}</When>
      <When condition={hasPreview}>{preview}</When>
    </Typography>
  );
};
